import fetch from "../fetch";

export default ({ contactFundId, fundId }) =>
  fetch({
    path: `/hy/funds/${fundId}/contacts/${contactFundId}`,
    method: "DELETE",
  });
